module.exports = __webpack_public_path__ + "img/convenio-de-practicas9.d0ccca74.png";